import { render } from "./BatchingRulesPanel.vue?vue&type=template&id=6a10a6d0&scoped=true"
import script from "./BatchingRulesPanel.vue?vue&type=script&lang=js"
export * from "./BatchingRulesPanel.vue?vue&type=script&lang=js"

import "./BatchingRulesPanel.vue?vue&type=style&index=0&id=6a10a6d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a10a6d0"]])

export default __exports__